/*  Variable
   ========================================================================== */
/*  breakpoint
   ========================================================================== */
/*  Misc
   ========================================================================== */
/*  Section Colors
   ========================================================================== */
/*  The Big Guns
   ========================================================================== */
/*  The Next Wave
   ========================================================================== */
/*  Start Ups
   ========================================================================== */
/*  Future Tech
   ========================================================================== */
/*  Reviewed
   ========================================================================== */
/*  Tried & Tested
   ========================================================================== */
/*  Digital Life
   ========================================================================== */
/*  Other Colors
   ========================================================================== */
/*  Generic Colors
   ========================================================================== */
/*  Article Body Colors
   ========================================================================== */
/*  Footer
   ========================================================================== */
/*  AMP
   ========================================================================== */
#app .navigation .share-pane {
  padding-top: 0;
  float: left;
  height: 100%;
  width: 8.75rem;
  /* Mobile breakpoints */
}
@media (min-width: 1440px) {
#app .navigation .share-pane {
      width: 15.625rem;
}
}
#app .navigation .share-pane .share-toolbar {
    padding-top: 0.9375rem;
    /* Mobile breakpoints */
}
@media (min-width: 1440px) {
#app .navigation .share-pane .share-toolbar {
        padding-left: 0.9375rem;
}
}
#app .navigation .share-pane .share-toolbar .share-button-container .share-buttons-wrapper {
    height: 2.375rem;
    width: 12.0625rem;
    /* Mobile breakpoints */
}
@media (min-width: 1024px) {
#app .navigation .share-pane .share-toolbar .share-button-container .share-buttons-wrapper {
        width: 12.5rem;
}
}
#app .navigation .share-pane .share-toolbar .share-button-container .share-buttons-wrapper a:not(:first-child) {
      margin-left: 0.75rem;
}
#app .navigation .share-pane .share-toolbar .share-button-container .share-buttons-wrapper a.share-button {
      width: 2.375rem;
      height: 2.375rem;
}
#app .navigation .share-pane .share-toolbar .share-button-container .share-buttons-wrapper a.share-button.facebook svg {
        height: 1.125rem !important;
        width: 0.5rem !important;
}
#app .navigation .share-pane .share-toolbar .share-button-container .share-buttons-wrapper a.share-button.twitter svg {
        height: 0.875rem !important;
        width: 1.0625rem !important;
}
#app .navigation .share-pane .share-toolbar .share-button-container .share-buttons-wrapper a.share-button.email svg {
        height: 0.75rem !important;
        width: 1.0625rem !important;
}
#app .navigation .share-pane .shareCount {
    font-size: 24px;
    color: white;
    float: left;
    margin-top: 0.125rem;
    display: none;
    font-family: "Barlow", sans-serif;
    /* Mobile breakpoints */
}
@media (min-width: 1440px) {
#app .navigation .share-pane .shareCount {
        display: inline;
}
}
#app .navigation .share-pane .shareCount .value {
      font-size: 1.125rem !important;
      min-width: 5.125rem !important;
}
#app .navigation .share-pane .shareCount .shareText {
      font-size: 0.6875rem !important;
}
#app .navigation .share-pane .share-button svg {
    margin: auto;
}



// WEBPACK FOOTER //
// ./components/app-shell/Navigation.vue